import { getActiveZones } from "./index23.js";
import { recursiveSubdivision } from "./index76.js";
import { optimisePlots } from "./index79.js";
import { DefaultPlot, RgCreate } from "@project-rouge/rg-core";
import { Vector3toV3, differencePolygons, intersectPolygons, offsetPolygon } from "@project-rouge/rg-three";
import seedrandom from "seedrandom";
const pipeAddPlots = ([parent, { aggProps, optimise }]) => {
	const rvData = aggProps.dataset.rvData;
	const zones = getActiveZones(parent, aggProps);
	const face2face = aggProps.face2FaceSeparation ?? aggProps.dataset.aggConfig.face2FaceSeparation;
	const { corridorWidth, moduleDepth } = aggProps.dataset.aggConfig;
	const tailorData = {
		mainThreads: [],
		mainFrozenThreads: []
	};
	for (const zone of zones) {
		const divisionData = [];
		const zoneProps = aggProps.zones[zone.uuid];
		const rng = seedrandom(`${zoneProps.subdivisionSeed}`);
		for (let i = 0; i < zone.data.polygons.length; i++) {
			const { polygons: plotPolys, root } = recursiveSubdivision({
				poly: offsetZonePolygon({
					zone,
					zones,
					i,
					face2face
				}),
				rng,
				maxCount: zoneProps.maxPlotCount,
				maxLength: zoneProps.maxLength,
				minWidth: zoneProps.minWidth ?? corridorWidth + 2 * moduleDepth + face2face,
				minArea: zoneProps.minArea,
				allowLongitudinalSplit: zoneProps.allowLongitudinalSplit
			});
			divisionData.push(root);
			createPlots(retrimPolys(zone, i, plotPolys), zone, i, rvData);
		}
		if (optimise && zoneProps.maxPlotCount > 1) {
			const { tailorDataOut } = optimisePlots(zone, aggProps, divisionData);
			tailorData.mainThreads.push(...tailorDataOut.mainThreads);
			tailorData.mainFrozenThreads.push(...tailorDataOut.mainFrozenThreads);
		}
	}
	return [parent, tailorData];
};
function retrimPolys(zone, i, plotPolys) {
	let newPlotPolys = [];
	const originalZonePolygon = zone.data.polygons[i].map(Vector3toV3);
	newPlotPolys = plotPolys.map((poly) => poly.map(Vector3toV3)).flatMap((c) => intersectPolygons(originalZonePolygon, [c]));
	return newPlotPolys;
}
function createPlots(newPlotPolys, zone, i, rvData) {
	for (const polygon of newPlotPolys) {
		const plot = RgCreate({
			...DefaultPlot,
			parent: zone,
			data: {
				polygon,
				zonePolyIndex: i
			}
		}, rvData);
		zone.children.push(plot);
	}
}
function offsetZonePolygon({ zone, zones, i, face2face }) {
	let zoneOffset = offsetPolygon(zone.data.polygons[i], .5 * face2face);
	const otherZonePolys = zones.filter((z) => z !== zone).flatMap((z) => z.data.polygons.map((poly) => poly.map(Vector3toV3)));
	otherZonePolys.push(zone.data.polygons.filter((_v, index) => index !== i).flatMap((poly) => poly.map(Vector3toV3)));
	if (otherZonePolys.length > 0) zoneOffset = differencePolygons(zoneOffset, otherZonePolys)[0];
	return zoneOffset;
}
export { pipeAddPlots };

//# sourceMappingURL=index80.js.map